import { money } from "../../Subscription/money";

/**
 * CRM sales tax — the words and the preview arithmetic for the Settings section
 * and the office/practice tax cards. Pure, so it is tested.
 *
 * The RULES (how many lines, what a rate may be) are the server's alone
 * (usage.services.tax_rules); a form shows the server's message rather than
 * repeating them here.
 */

// The server's ceiling (tax_rules.MAX_LINES); only used to hide "Add a tax".
export const MAX_LINES = 3;

export const emptyLine = () => ({ label: "", percent: "" });

/** Server rule lines ([{label, rate, percent}]) -> form lines ([{label, percent}]). */
export function formLines(lines) {
  return (lines || []).map((line) => ({ label: line.label || "", percent: line.percent || "" }));
}

/** "HST 13%" / "GST 5% + PST 7%" / "No sales tax". */
export function linesText(lines) {
  if (!lines || !lines.length) return "No sales tax";
  return lines.map((line) => `${line.label} ${line.percent}%`).join(" + ");
}

/**
 * "A $100.00 charge becomes $112.00" — each line rounded half-up to the cent on
 * its own, as the server charges it. Integer arithmetic: 100 × 9.975 is
 * 997.4999… in floating point. "" while any rate isn't a number yet.
 */
export function previewText(lines, baseDollars = 100) {
  const baseCents = Math.round(baseDollars * 100);
  let taxCents = 0;
  for (const line of lines || []) {
    const thousandths = Math.round(Number(String(line.percent).trim()) * 1000);
    if (String(line.percent).trim() === "" || !Number.isFinite(thousandths)) return "";
    taxCents += Math.round((baseCents * thousandths) / 100000);
  }
  return `A $${money((baseCents / 100).toFixed(2))} charge becomes $${money(((baseCents + taxCents) / 100).toFixed(2))}.`;
}

/** Where an office's tax comes from, in a sentence. */
export function sourceText(summary) {
  if (!summary) return "";
  const province = summary.province && summary.province.name;
  switch (summary.source) {
    case "office":
      return "Set for this office.";
    case "practice":
      return "Set for the whole practice.";
    case "province":
      return `The ${province} rate.`;
    case "default":
      return province
        ? `The default — no ${province} rate is set yet.`
        : `The default — we can't tell the office's province from "${summary.state || "(blank)"}".`;
    default:
      return "The legacy 13% HST — no default rate is set. Set one in CRM Settings → Sales tax.";
  }
}
